/**
 * Modo operativo del sistema según backend (1=Gestión, 2=Gestión+Facturación, 3=Solo Facturación)
 */
export enum OperationalMode {
  Gestion = 1,
  GestionConFacturacion = 2,
  Facturacion = 3,
}

export const isGestionEnabled = (mode: OperationalMode) =>
  mode === OperationalMode.Gestion || mode === OperationalMode.GestionConFacturacion;

export const isFacturacionEnabled = (mode: OperationalMode) =>
  mode === OperationalMode.GestionConFacturacion || mode === OperationalMode.Facturacion;
